/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".p[_ngcontent-%COMP%]{font-size:20px}.btn-outline-primary[_ngcontent-%COMP%]{color:#702963;border-color:#702963}.btn-outline-primary[_ngcontent-%COMP%]:active, .btn-outline-primary[_ngcontent-%COMP%]:hover, .btn-outline-primary[_ngcontent-%COMP%]:visited{background-color:#702963!important;color:#fff;border-color:#702963!important}.my-bg[_ngcontent-%COMP%]{background-image:url(login-bg.ae5d7f90dca7ac384323.png);height:100vh;margin-top:-43px;background-size:cover}"];
export { styles as styles };
